<template>
  <footer>

    <div class="footer-info">
      <b-container fluid>

        <div class="footer-logo">
            <router-link :to="{name: 'homepage'}"><LogoVivamod /></router-link>
        </div>


        <div class="links">
          <br/>
          <div class="panel-gray">
            <b-container fluid>
              <b-row class="linkList">
                <b-col sm="12" md="4" lg="4">
                  <div class="linkBlock">
                    <p class="linkTitle">
                      Viaggia con Vivamod
                    </p>

                    <a :href="vivamodHost">Prenota!</a>
                    <a :href="vivamodHost + 'covid-19'">Covid-19</a>
                    <a :href="vivamodHost + 'perche-scegliere-vivamod'">Viaggiare con Vivamod</a>
                    <a :href="vivamodHost + 'faq'">Domande frequenti</a>
                    <router-link :to="{name: 'blog'}" class="">Blog</router-link>
                  </div>
                </b-col>

                <b-col sm="12" md="4" lg="4">
                  <div class="linkBlock">
                    <p class="linkTitle">
                      Soluzioni Business
                    </p>

                    <!--<router-link :to="{name: 'homepage'}" class="">Vivamod business</router-link>-->
                    <router-link :to="{name: 'loyalty'}" class="">Soluzioni loyalty</router-link>
                    <router-link :to="{name: 'concorsi'}" class="">Soluzioni per concorsi</router-link>
                    <router-link :to="{name: 'regali'}" class="">Regali aziendali</router-link>
                    <router-link :to="{name: 'incentive'}" class="">Soluzioni per incentive</router-link>
                    <router-link :to="{name: 'blufreccia'}" class="">Blufreccia.com sport corporate</router-link>
                  </div>

                </b-col>

                <b-col sm="12" md="4" lg="4">
                  <div class="linkBlock">
                    <p class="linkTitle">
                      Vivamod | modern travel
                    </p>

                    <a :href="vivamodHost + 'informazioni#about'">Chi siamo</a>
                    <a :href="vivamodHost + 'informazioni#assistenza'">Contatti</a>

                    <a :href="privacyPolicyUrl" target="_blank">Privacy Policy</a>
                    <a :href="'https://www.iubenda.com/privacy-policy/88771384/cookie-policy'" target="_blank">Cookie Policy</a>
                    <a :href="vivamodHost + '/termini-e-condizioni'">Termini e condizioni</a>
                  </div>
                </b-col>

              </b-row>
            </b-container>

          </div>
        </div>


        <div class="footer-bottom">
          <a href="#">© SALABAM SRL - P.IVA: 04238550406</a>
          <a href="http://www.taiview.com" target="_blank">Ui & Ux Design: taiview.com</a>
          <div class="footer-social">
            <a href="https://www.facebook.com/vivamodtravel/" target="_blank"><Facebook /></a>
            <a href="https://www.linkedin.com/company/vivamod/" target="_blank"><Linkedin /></a>
            <a href="https://www.instagram.com/vivamod_modern_travel/" target="_blank"><Instagram /></a>
            <a href="/blog"><SvgBlog /></a>
          </div>
        </div>

      </b-container>
    </div>

    <BackToTop bottom="50px" right="50px" visibleoffset="600">
      <b-button class="btn-rounded">
        <SvgChevronUp />
      </b-button>
    </BackToTop>

  </footer>
</template>

<script>

//import Vue from "vue"
import Facebook from '@/components/svg/facebook'
import Instagram from '@/components/svg/instagram'
import Linkedin from '@/components/svg/linkedin'
import LogoVivamod from '@/components/svg/logo-vivamod'
import BackToTop from 'vue-backtotop'
import SvgChevronUp from '@/components/svg/chevron-up'
//import Prefooter from '../blocks/common/prefooter'
//import PrefooterWhite from '../blocks/common/prefooter-white'
import SvgBlog from '@/components/svg/blog'

export default {
  name: 'page-footer',
  components:
        {
            Facebook,
            Instagram,
            Linkedin,
            LogoVivamod,
            BackToTop,
            SvgChevronUp,
            SvgBlog,
        },
  props: {
    footerMenu: String,
    btnText: String,
  },
  data (){
    return {
      privacyPolicyUrl: process.env.VUE_APP_PRIVACY_POLICY_URL,
      vivamodHost: process.env.VUE_APP_VIVAMOD_HOST,
    }
  },
  computed: {
  },
}
</script>


<style lang="scss">
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/mixins";
@import './../../../scss/_custom.scss';

footer
{
  .footer-info
  {
    position:relative;
    overflow:hidden;
    .poweredBy
    {
      left:50%;
      right:auto;
      top:0;
      transform-origin: top center;;
      transform:translateX(-50%) scale(0.75);
      margin:0 auto;
      position:absolute;
      //background:$light-gray;
    }
  }
}

.footer-info
{
  text-align:center;
  padding-top:90px;
  padding-bottom:60px;
  //@include theme-background-color("tertiary");
  //vadobay bianco, customizzazione sovrascritta con data attributes
  background:$tertiary;

  .footer-menu a
  {
    //@include dynamic-colors-blend();
    color:$white;
  }
}

.footer-logo
{
  display:flex;
  justify-content:center;
  path
  {
      fill:$white;
  }
  img,svg
  {
    max-width: 300px;
    margin:1rem auto;
  }
}

.footer-menu
{
  display:flex;
  flex-direction: column;
  margin:50px auto;
  justify-content: center;
  list-style: none;
  li
  {
    &:not(last-child)
    {
      //border-right:1px solid $black;
    }
  }

  a
  {
    //@include theme-color("white");
    color:$white;
    //@include dynamic-colors-blend();
  }
}

.footer-bottom
{
  display:flex;
  flex-direction: column;
  font-size:14px;
  padding-top:70px;
  padding-bottom:70px;
  & > *:not(:last-child)
  {
    margin-bottom:20px;
  }
  a
  {
    color:$white;
  }
  svg
  {
    margin:0 20px 0 0;
    path,rect
    {
        fill:$white;
    }
  }
}

@include media-breakpoint-up(lg)
{
  .footer-menu
  {
    display:flex;
    flex-direction: row;
    margin:50px 0 100px 0;
    li
    {
      &:not(:last-child) a
      {
        margin-right:20px;
        padding-right:20px;
        border-right:1px solid;
      }
    }
  }

  .footer-bottom
  {
    flex-direction:row;
    justify-content:space-between;
    align-items: center;
    & > *:not(:last-child)
    {
      margin-bottom:0;
    }
    & > *
    {
      flex:33%;
      width:33%;
      text-align:center;
    }
  }
}

.vue-back-to-top .btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  min-width:auto;
  background:#FE7251;
  *
  {
      stroke:$white;
  }
}

.vue-back-to-top
{
  z-index:10 !important;
  .svg
  {
    //@include dynamic-colors-blend();
  }
}


.links
{

  text-align: left;

  .linkTitle, .linkTitle a
  {
    color:$white;
    font-size: 16px!important;
    font-weight: 600;
    margin-bottom:1rem!important;
  }
  .linkList a
  {
    color:$white;
    font-size: 13px;
    font-weight: 600;
    display:block;
    margin-bottom:0.5rem;
  }
  
  .col-lg-4
  {
    display: flex;
    justify-content: center;
  }
}

.footer-social
{
    display:flex;
    align-items: center;
    justify-content: center;
    svg
    {
        height:auto;
        width:37px;
    }
    a
    {
        transition:$transition-base;
        cursor:pointer;
        &:hover
        {
            opacity:0.75;
        }
    }
}

</style>